// Module
var code = `<h1>Медийная реклама</h1> <h3 class="metric-meaning">Что значит?</h3><p>Трафик, отправленный из других доменов через известную рекламную сеть, например Google Ads, Yandex Direct, Skimlinks и т.д</p> `;
// Exports
module.exports = code;